import { render, staticRenderFns } from "./video.vue?vue&type=template&id=1019a704&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&lang=css&"
import style1 from "./video.vue?vue&type=style&index=1&id=1019a704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019a704",
  null
  
)

export default component.exports